import WPAPI from "wpapi";

import { error } from "../util/rollbar";

const wordpressHost = "https://duolingo.wpengine.com";

const wp = new WPAPI({
  endpoint: `${wordpressHost}/wp-json/`,
});

const pagesApi = wp
  .pages()
  // Add in a specific header for Wordpress to distinguish requests.
  // This will allow us to control which requests can be allowed and which ones to block.
  // This is not really security-related, but more to prevent users and search engines
  // from ending up on the wrong (broken) Wordpress domain
  .setHeaders("X-Duolingo-Service-Key", "campaign-web");

/**
 *
 * @param id page id
 * @returns HTML for a particular Wordpress page
 */
export const getWordpressPageById = async (id: number) => {
  try {
    // Fetch pages
    const pages = await pagesApi.id(id).get();
    return pages.content.rendered;
  } catch (e) {
    // print error
    // eslint-disable-next-line no-console
    console.log(e);
    error("Error loading wordpress", {
      data: { pageId: id },
      ex: e instanceof Error ? e : undefined,
    });
    throw e;
  }
};

/**
 *
 * @param id page id
 * @returns All data associated with a Wordpress page
 */
export const getAllWordpressPageDataById = async (id: number) => {
  try {
    // Fetch pages
    const pageData = await pagesApi.id(id).get();
    return pageData;
  } catch (e) {
    // print error
    // eslint-disable-next-line no-console
    console.log(e);
    error("Error loading wordpress", {
      data: { pageId: id },
      ex: e instanceof Error ? e : undefined,
    });
    throw e;
  }
};
